module.exports = __webpack_public_path__ + "img/tbank.885098f3.svg";